export enum ActionTypes {
    QUESTION_WITH_CHOICE_TOGGLE_ANSWER_IS_SELECTED = 'QUESTION_WITH_CHOICE_TOGGLE_ANSWER_IS_SELECTED',
    QUESTION_WITH_CHOICE_SET_SINGLE_ANSWER_SELECTED = 'QUESTION_WITH_CHOICE_SET_SINGLE_ANSWER_SELECTED',
    SET_SINGLE_ANSWER_SELECTED = 'SET_SINGLE_ANSWER_SELECTED'
}

type AnswerIsSelected = {
    type: ActionTypes.QUESTION_WITH_CHOICE_TOGGLE_ANSWER_IS_SELECTED,
    payload: {
        questionId: string,
        answerId: string
    }
}

type QuestionWithChoiceSingleAnswerSelected = {
    type: ActionTypes.QUESTION_WITH_CHOICE_SET_SINGLE_ANSWER_SELECTED,
    payload: {
        questionId: string,
        answerId: string
    }
}

type SingleAnswerSelected = {
    type: ActionTypes.SET_SINGLE_ANSWER_SELECTED,
    payload: {
        questionId: string,
        answerId: string
    }
}

export type QuestionWithChoiceActionTypes = AnswerIsSelected | QuestionWithChoiceSingleAnswerSelected | SingleAnswerSelected;
